import { Box, Grid, Typography } from "@mui/material";
import MapFilter from "./MapFilter";

export default function MapFilterContainer({
  categories,
  regions,
  zipcodes,
  handleToggle,
}) {
  return (
    <Box>
      <Typography
        variant="h4"
        component="p"
        color="common.black"
        sx={{ marginBottom: "1rem" }}
      >
        Filter
      </Typography>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <MapFilter
            categories={categories}
            regions={regions}
            zipcodes={zipcodes}
            handleToggle={handleToggle}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
